<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          color="secondary--text"
          class="mx-1"
          @click="sharePermalinkDialogShow = true"
        >
          <v-icon>mdi-export-variant</v-icon>
        </v-btn>
      </template>
      <span> Share this {{ $t(objectType) }} </span>
    </v-tooltip>

    <v-dialog v-model="sharePermalinkDialogShow" persistent max-width="380">
      <v-card>
        <v-card-title> Share this {{ $t(objectType) }} </v-card-title>
        <v-card-text>
          <div class="mb-3">Use the following link to share this {{ $t(objectType) }}:</div>
          <span class="text-subtitle-2">{{ permalink }}</span>
          <!-- <sl-permalink :link="permalink" /> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" text outlined @click="sharePermalinkDialogShow = false">
            <v-icon>mdi-close</v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

// import SlPermalink from '@/components/SlPermalink'

export default {
  props: {
    permalink: {
      type: String,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
      validator: function(value) {
        // The value must match one of these strings
        return ['workspace', 'master', 'instance'].indexOf(value) !== -1
      },
    },
  },

  components: {
    // SlPermalink,
  },

  data: () => ({
    sharePermalinkDialogShow: false,
  }),

  computed: {
    // ...mapState(['userLogged']),
  },

  methods: {
    removeAskConfirmation() {
      this.sharePermalinkDialogShow = true
    },
    removeCancel() {
      this.sharePermalinkDialogShow = false
    },
    removeConfirm() {
      Logger.debug('removeConfirm')
    },
    ...mapMutations(['toastSet']),
  },
}
</script>

<style></style>
